import React, { useEffect } from 'react';
import Text from '@components/Text/Text';
import Button from '@components/Button/Button';
import Link from '@components/Link/Link';
import { ErrorContainer, ErrorMessage, ErrorIcon, ErrorContactWrapper, ErrorButtonWrapper } from './Error.styled';
import { AmplifyLogs, UIConstants } from '@constants';
import { useDispatch } from 'react-redux';
import { dismissNotification } from '@store/errors';
import { logUserEvent } from '@analytics/amplifyLogging';
import { v4 } from 'uuid';
import { config } from '../../config';
const { contactUs, phoneNo } = UIConstants.errorComponent;

export const ErrorComponent: React.FC<any> = ({ isHomeSectionNeeded, errorMsg, errorTextHeading }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const request = config.env('redirectUri');
        const correlationId = v4();
        const attributes = {
            ...AmplifyLogs.errPageRedirection
        };
        logUserEvent(attributes);
    }, []);

    const clickHomeButton = () => {
        dispatch(dismissNotification());
        window.location.reload();
    };

    return (
        <ErrorContainer id="errorContainer">
            <ErrorMessage id="errorMessage">
                <Text textVariant="h1" textMarginBottom="40px" textWeight="Regular">
                    {errorTextHeading}
                </Text>
                <Text textVariant="h2" textWeight="Regular" textMarginBottom="40px">
                    {errorMsg}
                </Text>
                {!isHomeSectionNeeded && (
                    <ErrorButtonWrapper>
                        <Link
                            onClick={clickHomeButton}
                            data-testid="homeButton"
                            id="homeButton"
                            eventAttributes={AmplifyLogs.errPageHomeBtn}
                        >
                            <Button text="Home" themeType="primary" width="12.8rem" />
                        </Link>
                        <ErrorContactWrapper>
                            <Text textVariant="h2" textWeight="Regular">
                                {contactUs}&nbsp;
                            </Text>
                            <Link href={`tel:+${phoneNo.replace(/-/g, '')}`} target="_blank" rel="noreferrer">
                                <Text textVariant="h2" textWeight="Regular">
                                    {phoneNo}
                                </Text>
                            </Link>
                        </ErrorContactWrapper>
                    </ErrorButtonWrapper>
                )}
            </ErrorMessage>
            <ErrorIcon>
                <img id="errorIcon" src={UIConstants.icons.errorIcon} alt="errorIcon" />
            </ErrorIcon>
        </ErrorContainer>
    );
};

export default React.memo(ErrorComponent);
